/* eslint-disable jsx-a11y/anchor-has-content */
import { yupResolver } from '@hookform/resolvers/yup'
import Modal from 'components/UI/modal/modal'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLkVerifyOrderMutation } from 'redux/api/lk.api'
import { mobilePhoneSelector } from 'redux/store/slices/application-slice'
import tw from 'twin.macro'
import * as yup from 'yup'

import AcceptDenominationChoice from './accept-denomination-choice'
import OtpVerify from './otp-verify'

function BuyCardLkModal({
  open,
  onClose,
  denomination
}: {
  open: boolean
  onClose: () => void
  denomination?: { amount: string; product_code: string }
}) {
  const [activeTitle, setActiveTitle] = useState<string | null>()
  // const [otpSuccess, setOtpSuccess] = useState<boolean>(false)
  // const [otpOpen, setOtpOpen] = useState<boolean>(false)
  const { t } = useTranslation()
  const mobile_phone = useSelector(mobilePhoneSelector)
  const navigate = useNavigate()
  const schema = useMemo(
    () =>
      yup.object({
        mobile_phone: yup.string().trim().min(16).required()
      }),
    [t]
  )
  const {
    control,
    formState: { isValid },
    getValues,
    setError,
    watch,
    reset
  } = useForm({ defaultValues: { code: '' }, resolver: yupResolver(schema) })

  const [otpVerify, { isSuccess: verifySuccess, isLoading: otpVerifyLoading, data: redirectUrl }] =
    useLkVerifyOrderMutation()

  const handleOtpVerify = async () => {
    try {
      await otpVerify({ code: watch('code') }).unwrap()
    } catch (error) {
      const typedErr = error as {
        data: {
          error: { description: string }
        }
        status: number
      }
      if (typedErr.data.error.description) {
        setError('code', { type: 'validate', message: typedErr.data.error.description })
      }
    }
  }

  useEffect(() => {
    !open && reset()
  }, [open])

  useEffect(() => {
    redirectUrl && window.open(redirectUrl?.data?.url, '_self')
  }, [redirectUrl])

  return (
    <Modal open={open} onClose={onClose} withBackdrop={false} title={t('modal_title', { ns: 'otp' })}>
      <div tw='sm:w-[422px] w-[80vw]'>
        <OtpVerify
          phone={mobile_phone || ''}
          control={control}
          name='code'
          isOtpValid={isValid}
          isLoading={otpVerifyLoading}
          onOtpVerify={handleOtpVerify}
        />
      </div>
    </Modal>
  )
}

export default BuyCardLkModal
